<template>
  <div class="hello">
    <div class="container mt-5">
      <div class="select-calculator row">
        <div class="col-3">
          <label for="" class="mt-2">
            Selecione sua calculadora: 
          </label>
        </div>
        <div class="col" style="margin-left: -20px">
          <v-select class="form-control bg-yellow" v-model="selected" :options="options" :reduce="option => option.value" label="text"></v-select>
        </div>
        <hr style="margin-top: 10px; width: 100%; color:#FFB327; border:2px solid;">
      </div>

      <div class="content-calculator mt-3">
        <div v-if="selected === 'ProfitCalculator'">
          <ProfitCalculator />
        </div>
        <div v-if="selected === 'ProbabilityCalculator'">
          <ProbabilityCalculator />
        </div>
        <div v-if="selected === 'WinRateCalculator'">
          <WinRateCalculator />
        </div>
        <div v-if="selected === 'RoiCalculator'">
          <RoiCalculator />
        </div>
        <div v-if="selected === 'CashoutCalculator'">
          <CashoutCalculator />
        </div>
        <div v-if="selected === 'ResponsibilityCalculator'">
          <ResponsibilityCalculator />
        </div>
        <div v-if="selected === 'NetProfitCalculator'">
          <NetProfitCalculator />
        </div>
        <div v-if="selected === 'LayToBackCalculator'">
          <LayToBackCalculator />
        </div>
        <div v-if="selected === 'ProfitTraderCalculator'">
          <ProfitTraderCalculator />
        </div>
        <div v-if="selected === 'DutchingCalculator'">
          <DutchingCalculator />
        </div>
        <div v-if="selected === 'BonusCalculator'">
          <BonusCalculator />
        </div>
      </div>
      <!--<b-tabs content-class="mt-3">
        <b-tab title="Calculadora de Lucro" active>
          <div class="container-fluid m-auto">
            <ProfitCalculator />
          </div>
        </b-tab>
        <b-tab title="Calculadora de Probabilidade">
          <div class="container-fluid m-auto">
            <ProbabilityCalculator />
          </div>
        </b-tab>
        <b-tab title="Calculadora de Win Rate">
          <div class="container-fluid m-auto">
            <WinRateCalculator />
          </div>
        </b-tab>
        <b-tab title="Calculadora de ROI">
          <div class="container-fluid m-auto">
            <RoiCalculator />
          </div>
        </b-tab>
        <b-tab title="Calculadora de Cashout">
          <div class="container-fluid m-auto">
            <CashoutCalculator />
          </div>
        </b-tab>
        <b-tab title="Calculadora de Responsabilidade Lay">
          <div class="container-fluid m-auto">
            <ResponsibilityCalculator />
          </div>
        </b-tab>
        <b-tab title="Calculadora de Lucro Líquido Betfair">
          <div class="container-fluid m-auto">
            <NetProfitCalculator />
          </div>
        </b-tab>
        <b-tab title="Calculadora de Conversão Lay em Back">
          <div class="container-fluid m-auto">
            <LayToBackCalculator />
          </div>
        </b-tab>
        <b-tab title="Calculadora de Lucro de Trade Esportivo">
          <div class="container-fluid m-auto">
            <ProfitTraderCalculator />
          </div>
        </b-tab>
        <b-tab title="Calculadora Dutching / Bookmaking">
          <div class="container-fluid m-auto">
            <DutchingCalculator />
          </div>
        </b-tab>
        <b-tab title="Calculadora Método de Bônus">
          <div class="container-fluid m-auto">
            <BonusCalculator />
          </div>
        </b-tab>
      </b-tabs>-->
    </div>
  </div>
</template>

<script>
import ProfitCalculator from "@/components/calculator/ProfitCalculator.vue"
import ProbabilityCalculator from "@/components/calculator/ProbabilityCalculator.vue"
import WinRateCalculator from "@/components/calculator/WinRateCalculator.vue"
import RoiCalculator from "@/components/calculator/RoiCalculator.vue"
import CashoutCalculator from "@/components/calculator/CashoutCalculator.vue"
import ResponsibilityCalculator from "@/components/calculator/ResponsibilityCalculator.vue"
import NetProfitCalculator from "@/components/calculator/NetProfitCalculator.vue"
import LayToBackCalculator from "@/components/calculator/LayToBackCalculator.vue"
import ProfitTraderCalculator from "@/components/calculator/ProfitTraderCalculator.vue"
import DutchingCalculator from "@/components/calculator/DutchingCalculator.vue"
import BonusCalculator from "@/components/calculator/BonusCalculator.vue"

export default {
  name: 'HelloWorld',
  components: {
    ProfitCalculator,
    ProbabilityCalculator,
    WinRateCalculator,
    RoiCalculator,
    CashoutCalculator,
    ResponsibilityCalculator,
    NetProfitCalculator,
    LayToBackCalculator,
    ProfitTraderCalculator,
    DutchingCalculator,
    BonusCalculator,
  },
  data() {
    return {
      selected: 'ProfitCalculator',
      options: [
        { value: 'ProfitCalculator', text: 'Calculadora de Lucro' },
        { value: 'ProbabilityCalculator', text: 'Calculadora de Probabilidade' },
        { value: 'WinRateCalculator', text: 'Calculadora de Win Rate' },
        { value: 'RoiCalculator', text: 'Calculadora de ROI' },
        { value: 'CashoutCalculator', text: 'Calculadora de Cashout' },
        { value: 'ResponsibilityCalculator', text: 'Calculadora de Responsabilidade Lay' },
        { value: 'NetProfitCalculator', text: 'Calculadora de Lucro Líquido Betfair' },
        { value: 'LayToBackCalculator', text: 'Calculadora de Conversão Lay em Back' },
        { value: 'ProfitTraderCalculator', text: 'Calculadora de Lucro de Trade Esportivo' },
        { value: 'DutchingCalculator', text: 'Calculadora Dutching' },
        { value: 'BonusCalculator', text: 'Calculadora Método de Bônus' },
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
